import { Provider } from '@angular/core';

import { OnBoardingVideoRepositoryImpl } from '@app/data/repositories/on-boarding-video/on-boarding-video-repository';
import { ON_BOARDING_VIDEO_REPOSITORY } from '@app/domain/repositories/on-boarding-video.repository.contract';

export const onBoardingVideoRepositoryProvider: Provider = {
  provide: ON_BOARDING_VIDEO_REPOSITORY,
  useClass: OnBoardingVideoRepositoryImpl
};
